/**
 * Shared helpers for sample orders (default SKU9999 line + mapped sample products).
 */
(function (global) {
  const DEFAULT_SAMPLE_VARIANT_ID = 49538592735516;

  function isSampleLineItem(item) {
    if (!item) return false;
    const variantId = item.variant_id || item.id;
    if (variantId === DEFAULT_SAMPLE_VARIANT_ID) return true;
    if (item.properties && item.properties._sample_order) return true;
    if (item.product_tags && item.product_tags.indexOf("sample-product") !== -1) {
      return true;
    }
    return false;
  }

  function countSampleProperties(properties) {
    if (!properties) return 0;
    return Object.keys(properties).filter(function (key) {
      if (key.charAt(0) === "_") return false;
      const val = properties[key];
      return val != null && String(val).trim() !== "";
    }).length;
  }

  function getTotalSampleCount(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (total, item) {
      if (!isSampleLineItem(item)) return total;
      return total + countSampleProperties(item.properties);
    }, 0);
  }

  function findSampleLineForVariant(cart, variantId) {
    if (!cart || !cart.items) return null;
    const id = parseInt(variantId, 10);
    return (
      cart.items.find(function (item) {
        return (item.variant_id || item.id) === id;
      }) || null
    );
  }

  function buildSampleProperties(existingProperties, mainSku, mainName) {
    const properties = Object.assign({}, existingProperties || {});
    properties._sample_order = "true";
    properties[mainSku] = mainName;
    return properties;
  }

  function propertiesOnlyMarkerLeft(properties) {
    return countSampleProperties(properties) === 0;
  }

  function parseVariantIdFromGid(value) {
    if (value == null) return null;
    const stringValue = String(value);
    const variantMatch = stringValue.match(/ProductVariant\/(\d+)/);
    if (variantMatch) {
      return parseInt(variantMatch[1], 10);
    }
    return null;
  }

  function getCartJsonUrl() {
    const root =
      typeof window !== "undefined" &&
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    return root + "cart.js";
  }

  /**
   * Sync header count, cart drawer, and subtotal after AJAX sample changes.
   */
  function refreshThemeCart() {
    document.dispatchEvent(new CustomEvent("cart:update"));

    return fetch(getCartJsonUrl())
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const count = cart.item_count;

        document
          .querySelectorAll("[data-cart-count], .header_cart_count")
          .forEach(function (el) {
            el.textContent = count;
            if (count === 0) {
              el.classList.add("shide");
            } else {
              el.classList.remove("shide");
            }
          });

        const totalEl = document.querySelector(".cart_total_price");
        if (
          totalEl &&
          typeof theme !== "undefined" &&
          theme.Currency &&
          theme.moneyFormat
        ) {
          totalEl.innerHTML = theme.Currency.formatMoney(
            cart.total_price,
            theme.moneyFormat,
          );
        }

        return cart;
      })
      .catch(function (error) {
        console.error("[sample-order] Failed to refresh cart UI:", error);
      });
  }

  global.SampleOrder = {
    DEFAULT_SAMPLE_VARIANT_ID: DEFAULT_SAMPLE_VARIANT_ID,
    isSampleLineItem: isSampleLineItem,
    countSampleProperties: countSampleProperties,
    getTotalSampleCount: getTotalSampleCount,
    findSampleLineForVariant: findSampleLineForVariant,
    buildSampleProperties: buildSampleProperties,
    propertiesOnlyMarkerLeft: propertiesOnlyMarkerLeft,
    parseVariantIdFromGid: parseVariantIdFromGid,
    refreshThemeCart: refreshThemeCart,
  };
})(typeof window !== "undefined" ? window : this);
